import { Configuration, LogLevel } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || "/",
    postLogoutRedirectUri:
      process.env.REACT_APP_AZURE_POST_LOGOUT_REDIRECT_URI || "/",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage", // "localStorage" provides SSO between tabs, but less secure
    storeAuthStateInCookie: false, // Set to "true" if experiencing issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js adds OIDC scopes (openid, profile, email) to any login request.
 * offline_access is required to receive refresh tokens for silent token renewal.
 */
export const loginRequest = {
  scopes: [
    process.env.REACT_APP_API_SCOPE,
    "openid",
    "profile",
    "email",
    "offline_access",
  ].filter(Boolean) as string[],
};
